<template>
    <a-spin :spinning="false">
        <h3><ClockCircleOutlined/> <span v-if="!collapsed"> 最近阅读</span></h3>
        <div style="height: 55vh; overflow-y: auto; padding-left: 10px; color: #999; margin-top: 15px">
            <tempate v-for="(item, k) in dataSource" :key="k">
                <a-typography-paragraph :ellipsis="true" :class="item.upload_no === upload_no ? 'text active': 'text'">
                    <span style="cursor: pointer" @click="()=>overviewDetail(item)">{{item.title_cn}}</span>
                </a-typography-paragraph>
            </tempate>

        </div>
    </a-spin>
</template>

<script>
    import { ClockCircleOutlined} from '@ant-design/icons-vue';
    import {get_args, isDEV} from "../utils/request";
    import {
        get_aftergo_paper_upload_mine,
        jumpToDetail
    } from "../utils/bioinfo.api";
    export default {
        name: "PaperRecent",
        components: {
            ClockCircleOutlined
        },
        props: ['uploadNo', 'collapsed', 'account'],
        data(){
            let {upload_no} = get_args();
            return {
                isDEV,
                upload_no: Number(upload_no),
                loading: true,
                dataSource: [],
                page: 1,
                pageSize: 10,
                total: 0,
            }
        },
        created(){
            this.getItems(this.page, this.pageSize);
        },
        methods: {
            getItems(){
                this.loading = true;
                if(this.account) get_aftergo_paper_upload_mine( res=>{
                    console.log('get_aftergo_paper_upload_mine', res);
                    this.loading = false;
                    this.dataSource = res?.data || [];
                    this.total = res?.total_records;
                })
            },
            overviewDetail(record){
                console.log(record);
                let {upload_no, paper_no} = record;
                jumpToDetail(upload_no, paper_no);
            },
        }
    }
</script>

<style scoped>
    .text{
        background: #fff;
        line-height: 12px;
        border-radius: 10px;
        padding: 10px;
        padding-right: 3px;
        margin-bottom: 0;
    }
    .active, .text:hover{
        background: #EAEAEA;
    }

    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .pubmed-width {
            width: 100%;
            /*border: 1px solid red;*/
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
        .modal-width{
            width: 98%
        }
    }

    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0px; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }
</style>